import { useMemo } from 'react';

interface Props {
  text: string;
  searchTerm: string;
}

export default function HighlightedText({ text, searchTerm }: Props) {
  const regex = useMemo(() => {
    return searchTerm.trim() ? new RegExp(`(${searchTerm})`, 'gi') : /^$/;
  }, [searchTerm]); // eslint-diable-line

  if (!searchTerm.trim()) {
    return <span>{text}</span>;
  }
  const parts = text.split(regex);
  return (
    <div className="bw-100 d-flex-r ai-center omit-text-1 line-height-30">
      {parts.map((part, index) => {
        const isMatch = part.toLowerCase() === searchTerm.toLowerCase();
        return isMatch ? (
          <span key={index} style={{ color: 'red', fontWeight: 'bold' }}>
            {part}
          </span>
        ) : (
          <span key={index}>{part}</span>
        );
      })}
    </div>
  );
}
